<!-- TODO: Create the logic to add variations and to hide and remove the alert -->
<template>
	<div class="alert-container" v-show="displayAlert">
		<div
			:class="['alert', variant]"
			:disabled="disabled"
			:variant="variant"
			:id="uid"
		>
			<div class="alert__body">
				<p class="alert__title">{{ title }}</p>
				<p :class="messageClassName">
					{{ message }}
				</p>
			</div>
			<div class="alert__close-btn">
				<Button
					id="close"
					className="btn--icon-only"
					iconClassName="icon-close"
					:btnClick="closeWindow"
					:iconBeforeLabel="false"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import Button from '@/components/forms/button/button';

export default {
	name: 'Alert',
	components: {
		Button
	},
	props: {
		variant: {
			type: String,
			default: ''
		},
		title: {
			type: String,
			default: ''
		},
		messageClassName: {
			type: String,
			default: 'alert__message'
		},
		message: {
			type: String,
			default: ''
		},
		display: {
			type: Boolean,
			default: false
		},
		hasTimer: {
			type: Boolean,
			default: true
		},
		timerLength: {
			type: Number,
			default: 5000
		}
	},
	data() {
		return {
			displayAlert: this.display
		};
	},
	watch: {
		display() {
			this.displayAlert = this.display;
		}
	},
	mounted() {
		if (this.hasTimer) {
			let timer = this.timerLength;
			setTimeout(() => {
				this.closeWindow();
			}, timer);
		}
	},
	methods: {
		closeWindow() {
			this.displayAlert = false;
			this.$emit('close', true);
		}
	}
};
</script>

<style lang="scss">
/**
    * 
    * Global Alerts
    * Can use SCSS variables = TRUE
    *
 */

/*------------------------------------*\
  #ALERT CONTAINER
\*------------------------------------*/
.alert-container {
	@include contain(1200px);
	@include vertical-center-with-transform;
	position: fixed;
	z-index: 9999;
	display: flex;
	flex-direction: column;
	width: 100%;
	top: $alert-container-top;
	right: 0;
}

/*------------------------------------*\
  #BASE
\*------------------------------------*/

.alert {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: $alert-padding;
	font-size: $alert-font-size;
	border-radius: $alert-border-radius;
	margin-bottom: $alert-margin-bottom;
	@include slide-down-in;

	&__body {
		display: flex;
		align-items: center;
		justify-content: space-between;

		@include mq($until: lg) {
			flex-direction: column;
			align-items: flex-start;

			.alert__title {
				padding-bottom: 8px;
			}
		}
	}

	&__title {
		display: flex;
		justify-content: start;
		align-items: center;
		text-transform: uppercase;
		font-weight: $alert-title-font-weight;
		font-size: inherit;
		padding-right: 8px;
	}

	&__message {
		font-size: inherit;

		&::before {
			content: ' - ';

			@include mq($until: lg) {
				content: '';
			}
		}
	}

	&--neutral {
		background: $alert-neutral-bkgd;

		> * {
			color: $base-text-dark;
		}
	}

	&--error {
		background: $alert-error-bkgd;

		> * {
			color: $white;
		}

		.btn--icon-only .icon:hover {
			color: $white;
		}
	}
}
</style>
